var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconMinibus = function SvgIconMinibus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 18.9a2.737 2.737 0 0 1-2.578-1.823A2.736 2.736 0 0 1 1.35 14.5V7.833A2.736 2.736 0 0 1 4.083 5.1h10.144c.728 0 1.416.285 1.933.8l3.758 3.757c.355.357.803.61 1.294.733l.155.047a1.9 1.9 0 0 1 1.283 1.797V14.5a2.737 2.737 0 0 1-1.823 2.578A2.736 2.736 0 0 1 18.25 18.9c-1.13 0-2.1-.687-2.516-1.666H8.266A2.737 2.737 0 0 1 5.75 18.9zm12.5-3.627a.896.896 0 0 0-.894.894c0 .492.402.893.894.893a.896.896 0 0 0 .894-.893.896.896 0 0 0-.894-.894zm-12.5 0a.896.896 0 0 0-.894.894c0 .492.402.893.894.893a.896.896 0 0 0 .894-.893.896.896 0 0 0-.894-.894zm8.477-8.04H4.083c-.33 0-.6.27-.6.6V14.5c0 .042.005.082.013.122a2.733 2.733 0 0 1 4.77.478h7.467a2.732 2.732 0 0 1 4.77-.48l.006-.023.008-.097-.001-2.089-.08-.022a4.908 4.908 0 0 1-1.835-1.04l-.193-.183-3.759-3.757a.606.606 0 0 0-.422-.176z",
    fill: "var(--colors-brand)",
    fillRule: "evenodd"
  })));
};

export default SvgIconMinibus;